import React, { useEffect } from 'react';
import { Steps } from 'intro.js-react';
import 'intro.js/introjs.css';
import { useGuide } from '../context/GuideContext';

// 페이지별 가이드 단계 정의
const tourSteps = {
  // 홈페이지 가이드
  home: [
    {
      element: 'h1',
      intro: 'AI 기반 질의응답 시스템에 오신 것을 환영합니다!',
      position: 'bottom'
    },
    {
      element: 'button[data-guide="start-chat"]',
      intro: '이 버튼을 클릭하여 AI와의 대화를 시작할 수 있습니다.',
      position: 'bottom'
    },
    {
      element: '[data-guide="features"]',
      intro: '이 섹션에서는 시스템의 주요 기능들을 확인할 수 있습니다.',
      position: 'top'
    },
    {
      element: '[data-guide="crawling"]',
      intro: '웹 크롤링 기능을 통해 웹사이트와 다양한 파일 형식을 자동으로 수집할 수 있습니다.',
      position: 'left'
    },
    {
      element: '[data-guide="documents"]',
      intro: '다양한 형식의 문서를 업로드하고 관리할 수 있습니다.',
      position: 'top'
    },
    {
      element: '[data-guide="database"]',
      intro: '외부 데이터베이스와 연동하여 데이터를 가져올 수 있습니다.',
      position: 'right'
    },
    {
      element: '[data-guide="knowledge-base"]',
      intro: '수집된 데이터를 기반으로 AI가 활용할 지식베이스를 구축할 수 있습니다.',
      position: 'bottom'
    },
    {
      element: '[data-guide="admin-button"]',
      intro: '관리자는 이 버튼을 통해 관리자 페이지로 이동할 수 있습니다.',
      position: 'left'
    }
  ],
  
  // 채팅 페이지 가이드
  chat: [
    {
      element: '[data-guide="knowledge-base-selector"]',
      intro: '지식베이스를 1개 이상 선택 후 질문을 하실 수 있습니다. 선택하신 웹사이트 내에서 궁금하신 사항에 대해 질문을 하시면 AI 가 답변을 드립니다.',
      position: 'bottom'
    },
    {
      element: '[data-guide="chat-input"]',
      intro: '이곳에 질문을 입력하고 전송 버튼을 클릭하면 AI가 지식베이스를 기반으로 답변을 생성합니다. Enter 키를 눌러도 전송됩니다.',
      position: 'top'
    },
    {
      element: '[data-guide="chat-history"]',
      intro: '이곳에서 대화 내용을 확인할 수 있습니다.',
      position: 'bottom'
    },
    {
      element: '[data-guide="reference-documents"]',
      intro: '질문에 대한 답변 시 참조된 문서들이 이곳에 표시됩니다. 원본 문서 링크를 클릭하여 확인할 수 있습니다.',
      position: 'left'
    }
  ],
  
  // 관리자 페이지 가이드
  admin: [
    {
      element: '[data-guide="admin-sidebar"]',
      intro: '이 사이드바를 통해 다양한 관리 기능에 접근할 수 있습니다.',
      position: 'right'
    }
  ],
  
  // 크롤링 페이지 가이드
  crawl: [
    {
      element: '[data-guide="crawl-form"]',
      intro: '이곳에서 크롤링할 웹사이트 URL을 입력할 수 있습니다.',
      position: 'bottom'
    },
    {
      element: '[data-guide="crawl-options"]',
      intro: '다양한 크롤링 옵션을 설정할 수 있습니다.',
      position: 'right'
    }
  ],
  
  // 문서 관리 페이지 가이드
  documents: [
    {
      element: '[data-guide="upload-zone"]',
      intro: '이곳에 파일을 드래그&드롭하거나 클릭하여 문서를 업로드할 수 있습니다.',
      position: 'bottom'
    },
    {
      element: '[data-guide="documents-list"]',
      intro: '업로드된 문서 목록을 확인하고 관리할 수 있습니다.',
      position: 'top'
    }
  ],
  
  // 데이터베이스 연동 페이지 가이드
  database: [
    {
      element: '[data-guide="db-connection-form"]',
      intro: '이곳에서 외부 데이터베이스 연결 정보를 입력할 수 있습니다.',
      position: 'bottom'
    }
  ]
};

const TourGuide = () => {
  const { showGuide, currentPage, stopGuide } = useGuide();
  
  // 페이지별 가이드 단계 결정
  const steps = tourSteps[currentPage] || [];
  
  // 가이드 옵션
  const options = {
    nextLabel: '다음',
    prevLabel: '이전',
    doneLabel: '완료',
    hidePrev: false,
    hideNext: false,
    tooltipClass: 'customTooltip',
    highlightClass: 'customHighlight',
    exitOnOverlayClick: true,
    showStepNumbers: true
  };
  
  // 가이드 종료 핸들러
  const onExit = () => {
    stopGuide();
  };
  
  return (
    <Steps
      enabled={showGuide}
      steps={steps}
      initialStep={0}
      onExit={onExit}
      options={options}
    />
  );
};

export default TourGuide; 